import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const BestBetsFaqModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton style={{ borderBottom: '2px solid #dee2e6' }}>
        <Modal.Title>Best Bets FAQ</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <div style={{ padding: '20px' }}>
          <h5>What are Best Bets?</h5>
          <p>Best Bets automatically filters thousands of props to show you only the opportunities where one sportsbook is offering significantly better odds than the market.</p>

          <h5 style={{ marginTop: '24px' }}>What are the qualifying criteria?</h5>
          <p>A prop appears in Best Bets only when <strong>ALL</strong> of these are true:</p>
          <ol>
            <li><strong>3+ sportsbooks</strong> pricing the same market</li>
            <li><strong>Unique best odds</strong> - exactly one book has the best price (no ties)</li>
            <li><strong>5%+ edge</strong> - minimum 0.05 odds difference</li>
            <li><strong>Game not started</strong> - live/finished games excluded</li>
          </ol>

          <h5 style={{ marginTop: '24px' }}>What do the tier colors mean?</h5>
          <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
            <li style={{ marginBottom: '8px' }}><strong>🟢 Tier 1 (Green):</strong> 25%+ edge - Premium opportunity</li>
            <li style={{ marginBottom: '8px' }}><strong>🟠 Tier 2 (Orange):</strong> 15-24% edge - Strong value</li>
            <li style={{ marginBottom: '8px' }}><strong>🔵 Tier 3 (Blue):</strong> 5-14% edge - Solid advantage</li>
          </ul>

          <h5 style={{ marginTop: '24px' }}>Why do you require 3 sportsbooks?</h5>
          <p>With only 2 books, it's difficult to establish market consensus. A third book helps identify when one is likely out of line with the broader market.</p>

          <h5 style={{ marginTop: '24px' }}>Why don't I see certain props?</h5>
          <p>Common reasons props are filtered out:</p>
          <ul>
            <li>Fewer than 3 books offering that market</li>
            <li>Best odds tied between multiple books</li>
            <li>Edge below 5% threshold</li>
            <li>Game already started</li>
            <li>Locked games (free tier)</li>
          </ul>

          <h5 style={{ marginTop: '24px' }}>Are Best Bets guaranteed winners?</h5>
          <p>No. Best Bets identify <em>value opportunities</em> where you're getting better prices than the market, which improves your long-term expected value, but individual bets can still lose. Think of it like buying stocks on sale - you're getting a better price, but there's still risk involved.</p>

          <h5 style={{ marginTop: '24px' }}>Tips</h5>
          <div style={{ lineHeight: '2' }}>
            <div>✅ Act fast - edges disappear quickly</div>
            <div>✅ Prioritize Tier 1 (green) and Tier 2 (orange)</div>
            <div>✅ Track results to measure long-term improvement</div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BestBetsFaqModal;
